const environmentKey = {
    // TODO: Replace all end point to MBS end point
    development: {
        endPoint: 'https://api-digital-uat.maxis.com.my/uat/api/',
        aemEndPoint: 'https://productcatalog-staging.maxis.com.my',
        webURL: `https://aem-staging.business.maxis.com.my`,
        apiId: 'goiwi3vpib',
        x_apiKey: '6badd2d9-6fdf-49b2-bc79-d67534feb7e3',
        gMapsKey: 'AIzaSyB6xKuWaNOUXm9-fzRVqP8DcrR9GG7PyCg',
        fibreAddressLookupEndpoint: 'https://stg.daas-api.maxis.com.my/mapixpro/stg',
        fibreAddressLookupApiKey: 'AIzaSyBNx7WRLdce409gCXsey2w9qm-EEpWEUi8',
        fibreAddressLookupApiHeaders: {
            'x-daas-source-realtime-process': '1',
            'x-daas-source-channel': 'channel',
            'x-daas-source-correlationid': '0',
            'x-daas-source-timestamp': '20191107165612',
            'x-daas-source-countrycode': 'MY'
        },
        stagingTacCodeRetrievingEndPoint: 'https://api-digital-uat3.isddc.men.maxis.com.my',
        maxisFaceId: 'https://d1qm4oahkkwflz.cloudfront.net/home',
        maxisSSO: 'https://sso-uat.maxis.com.my',
        bizHub: 'https://api-onebizhubstg.maxis.com.my',
    },
    production: {
        endPoint: 'https://api-digital.maxis.com.my/prod/api/',
        aemEndPoint: 'https://productcatalog.maxis.com.my',
        webURL: `https://www.business.maxis.com.my`,
        apiId: 'a8pdjulkwe',
        x_apiKey: '81a71a2e-86ca-4f9c-a842-4a073e586802',
        gMapsKey: 'AIzaSyDfronNkAKkFdgBSkb--a5m_bDre21vM2s',
        fibreAddressLookupEndpoint: 'https://daas-api.maxis.com.my/mapixpro',
        fibreAddressLookupApiKey: 'AIzaSyD9LweVNsjgzSp1BaMk2OZQ4-pj1ftqPDA',
        fibreAddressLookupApiHeaders: {
            'x-daas-source-realtime-process': '1',
            'x-daas-source-channel': 'channel',
            'x-daas-source-correlationid': '0',
            'x-daas-source-timestamp': '20191107165612',
            'x-daas-source-countrycode': 'MY'
        },
        maxisFaceId: 'https://faceid.maxis.com.my/home',
        maxisSSO: 'https://sso.maxis.com.my',
        bizHub: 'https://api-onebizhub.maxis.com.my'
    }
};

export default environmentKey;
